import { User } from '@kfiroo/backgammon-core'
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'

import { useAuth } from '../firebase/FirebaseProvider'
import { SigninCheckResult, useSigninCheck } from '../firebase/hooks'

export interface AuthResult {
  user?: User
  loading: boolean
  errors: Record<string, unknown>
  signInWithGoogle: () => Promise<void>
}

export function useFirebaseAuth(): AuthResult {
  const auth = useAuth()
  const { status, data: signInCheckResult } = useSigninCheck()

  async function signInWithGoogle() {
    try {
      const provider = new GoogleAuthProvider()
      await signInWithPopup(auth, provider)
    } catch (err) {
      console.error('signInWithGoogle', err)
      throw err
    }
  }

  return {
    signInWithGoogle,
    user: makeUser(signInCheckResult),
    loading: status === 'loading',
    errors: signInCheckResult?.errors ?? {},
  }
}

function makeUser(signInCheckResult: SigninCheckResult): User | undefined {
  if (
    !signInCheckResult ||
    !signInCheckResult.signedIn ||
    !signInCheckResult.user
  ) {
    return undefined
  }
  const { uid, email, displayName, photoURL } = signInCheckResult.user
  if (!email || !displayName || !photoURL) {
    return undefined
  }
  return {
    uid,
    email,
    displayName,
    photoURL,
  }
}
